module.exports = __webpack_public_path__ + "img/office_dialog_icon01.beb2012e.png";